import { observer } from "mobx-react-lite";

import { Grid } from "@material-ui/core";

import { SuccessMessage } from "../SuccessMessage";

export const Completed = observer(function Completed() {
  return (
    <Grid container justify="center" spacing={1}>
      <Grid item xs={12}>
        <SuccessMessage
          icon="fa:check"
          title="Du hast deinen Benchmark abgeschlossen, vielen Dank"
          message="Du erhältst innerhalb der nächsten Minuten einen Link zu Deiner Auswertung."
        />
      </Grid>
    </Grid>
  );
});
